import { AbstractControl, ValidationErrors } from '@angular/forms';
import { SharedService } from './services/shared/shared.service';

export const COMMONTEXT = {
    INCOMPLETE_FORM: 'Please complete the form',
    INVALID_DATE: 'Please enter valid date',
    NO_RECORD: 'No record found',
    CANT_PREVIEW: 'Cant preview. Something went wrong',
    ERROR_OCCURED: 'Something went wrong, please try again',
    UPLOAD_IMAGE: 'Please upload image',
    UPLOAD_PDF: 'Please upload pdf',
    NOT_SUBMITTED: 'Form not submitted',
    NOT_MATCH: 'New password and old password doesn\'t match',
    UPDATE_PHONE_EMAIL: 'Please update your email and password',
    PASSWORD_CHANGED: 'Password successfully changed, please re-login',
    PROFILE: 'Profile successfully updated , please re-login',
    PASSWORD_MATCH: 'New password and confirm password doesn\'t match',
    OLD_NEW_MATCH: 'Old password and new password can\'t be same',
    SELECT_REASON: 'Please select status',
    API_ERROR: 'Something went wrong, please try after sometime',
    SAME_IF_UI: 'IFSC code and User Id should be same',
    MAND_IFSC: 'Please enter IFSC code',
    UPDATE_DRP: 'Please submit DRP details',
    UPDATE_MOBILE: 'Please update mobile no.',
    UPDATE_EMAIL: 'Please update email id',
    UPDATE_TRANSIENT: 'Please update transient account no.',
    STATUS: 'Please select status',
    REASON: 'Please select reason',
    DATE_OR_APPLICATION: 'Please provide either dates or application no.',
    INVALID_IFSC: 'IFSC code is not verified',
    ONE_DOC: 'Only one document can be uploaded',
    MAX_DOC_SIZE: 'Image too big (max 8MB)',
    INVALID_FORMAT: 'Invalid format',
    MATCH_NOT_AMOUNT: '\'Amount to be deposited by applicant as own contribution\' should be equal to \'amount deposited by applicant\'',
    AMOUNT_LESS_EQUAL: '\'Amount to be Disbursed in This Tranche\' should be less than or  equal to \'balance loan amount to be disbursed\'',
    AMOUNT_MANDATORY: 'Amount deposited by applicant is not provided',
    CORRECT_BATCH: 'Please enter correct batch number',
    CORRECT_REFERENCE: 'Please enter correct File Number',
    CORRECT_APPLICANT: 'Please enter correct Application Number',
    CONFIRMATION_HEADER: 'Confirm',
    CONFIRMATION_APP_SUB_Header: 'Are you sure want to submit?',
    CONFIRMATION_APP_MSG: 'Note: Once saved, data cannot be modified!!',
    CONFIRMATION_DELETE_MSG: 'Note: Once deleted, data cannot be restored!!',
    NO_ACTION: 'No action performed',
    DELETE_FROM_ROW: 'Are you sure want to delete?',
    UPLOAD_FILE: 'Please upload file',
    INCORRECT_CAPTCHA: 'Captcha is incorrect',
    DEACTIVATED_CONTENT: 'Selected course is de-activated, no action allowed',
    POP_UP_HEADER: 'Alert',
    NO: '',
    UPDATE_COURSE: 'Do you really want to update the course?',
    UPDATE_CONTENT: 'Do you really want to update the content?',
    DISABLE_COURSE: 'Do you really want to disable the course?',
    ENABLE_COURSE: 'Do you really want to enable the course?',
    CONCURRENT_LOGIN: 'User login from different browser',
    UN_AUTH: 'Unauthenticated Request',
    LOGOUT: 'Do you really want to logout',
    NO_DOC_UPLOADED: 'No document uploaded'
    // ENTER_MOBILE: 'Please '
};

export const APP_RELOAD = {
    TIMER: 1800000,
};

export const USERS = {
    AUTH: 'api/users/auth',
    UPDATE_PROFILE: 'api/users/updateProfile',
    VIEW_PROFILE: 'api/users/viewProfile/',
    CHANGE_INTERNAL_USER_PASSWORD: 'api/users/changeInternalUserPassword',
    RESET_INTERNAL_USER_PASSWORD: 'api/users/changeInternalUserPasswordV1',
    UPDATE_PASSWORD: 'api/users/updatePassword',
    UPDATE_USER: 'api/users/updateUser',
    RESET_PASSWORD: 'api/users/resetPassword',
    RESET_PASSWORD_WITH_OTP: 'api/users/resetPasswordWithOtpV1',
    SEARCH_USER: 'api/users/searchUser',
    SEARCH_INTERNAL_USER: 'api/users/searchInternalUser',
    SEARCH_USER_V2: 'api/users/searchUser/v2',
    FORGOT_PASSWORD: 'api/users/forgetPassword',
    REGISTER_INTERNAL_USER: 'api/users/registerInternalUser',
    GET_MENU_LIST: 'api/users/getMenuList',
    GET_USER_RIGHTS: 'api/users/getUserRights/',
    CREATE_USER_RIGHTS: 'api/users/createUserRights',
    UPDATE_USER_RIGHTS: 'api/users/updateUserRights',
    UPDATE_USER_TYPE_RIGHT: 'api/users/updateUserTypeRight',
    UPDATE_INTERNAL_USER: 'api/users/updateInternalUser',
    ACTIVATE_INTERNAL_USER: 'api/mis/activeInActiveUser/',
    GET_CAPTCHA: 'api/users/getCaptcha',
    VERIFY_CAPTCHA: 'api/users/verifyCaptcha',
    LOGOUT: 'api/users/logout',
    GET_DOMAIN_AND_PRODUCT_DETAILS: 'api/users/getDomainAndProductDetails/',
    DELETE_DOMAIN: 'api/users/deleteDomain/',
    UPDATE_INTERNAL_USER_MT_DLT: 'api/users/updateInternalUserForMtDlt',
    UPDATE_INCUBATION: 'api/master/updateIncubationDetails',
    UPDATE_INCUBATION_NEW: 'api/inc/updateIncubationDetails',
    SEARCH_INTERNAL_USERS: 'api/mis/getInternalUserList',
    SEARCH_USER_FOR_EXTENSION: 'api/users/searchInternalUsersStateWise',
    RONDOM_PASSWORD: 'api/users/sendResetPasswordEmail',


};

// { endPoint } /api/master / getDistricts / { stateCode }

export const MASTER = {
    GET_STATES: 'api/master/getStates',
    GET_DISTRICT: 'api/master/getDistricts/',
    GET_STATUS: 'api/master/getMasterStatus/',
    GET_ALL_USER_TYPES: 'api/master/getAllUserTypes',
    GET_BANK_NAME_LIST: 'api/master/getBankNameList',
    GET_PRODUCT_TYPE: 'api/master/getProductType',
    GET_PRODUCT_TYPE_REP: 'api/master/getProductType/',
    GET_FINANCIAL_YEAR: 'api/master/getFinancialPeriod/',
    GET_REPAY_TIME_FRAME_LIST: 'api/master/getRepayTimeFrameList/',
    GET_TRACK_REPAYMENT: 'api/master/getTrackRepayment/',
    GET_EXISTING_INFRA_MACHINE: 'api/master/getExistInfraMachine',
    GET_MASTER_REJ_DEF: 'api/master/masterRejDef/',
    REPORTING_QUARTER: 'api/master/reportingQuarter',
    GET_REPAYMENT_STATUS_LIST: 'api/master/getRepaymentStatusList',
    GET_ODOP_DETAILS: 'api/master/getStateOdopProduct/stateCode/',
    GET_LANGUAGE: 'api/master/getLanguage',
    GET_MASTER_PRODUCT_CODE_LIST: 'api/master/getMasterProductCodeList',
    GET_MASTER_TRAINING_LIST: 'api/master/getMasterTrainingList',
    GET_CMS_INSTITUTE: 'api/master/getCMSInstitute',
    GET_CONTENT_TYPE: 'api/master/getContentType',
    GET_CMS_DOC_RELATED: 'api/master/getCmsDocRelated',
    GET_LMS_DECISION_LIST: 'api/master/getLMSDecisionList',
    GET_MASTER_LMS_TRAINING_TYPE: 'api/master/getMasterLMSTrainingType',
    GET_QUALIFICATION: 'api/master/getQualification',
    GET_GUARDIAN_TYPE: 'api/master/getMasterGuardianType/',
    GET_MAIN_MENU: 'api/master/getAllMasterMainMenu/',
    GET_SUB_MENU: 'api/master/getAllMasterMenuLevel1',
    SAVE_MENU: 'api/master/saveOrUpdateMainMenuAndSubMenu',

};

export const LMS = {
    GET_ALL_COURSE: 'api/lms/getAllCourse',
    SAVE_COURSE: 'api/lms/saveCourse',
    UPLOAD_THUMBNAIL: 'api/lms/uploadThumbnail',
    GET_CONTENT: 'api/lms/getContent',
    SAVE_CONTENT: 'api/lms/saveContent',
    UPLOAD_CONTENT: 'api/lms/uploadContent',
    DOWNLOAD_CONTENT: 'api/lms/downloadContent',
    GET_COURSES_IF_CONTENT_EXIST: 'api/lms/getCoursesIfContentExist',
    SAVE_DECISION: 'api/lms/saveDecision',
    GET_CONTENT_TYPE_COUNT: 'api/lms/getContentTypeCount',
    GET_DECISION_HISTORY: 'api/lms/getDecisionHistory',
    ADD_TRAINING: 'api/lms/addTraining',
    VIEW_TRAINING: 'api/lms/viewTraining/',
    VIEW_TRAINEE: 'api/lms/viewTrainee/',
    LIST_TRAINEE: 'api/lms/listTrainees/',
    SEARCH_TRAINING: 'api/lms/searchTraining',
    CANCEL_TRAINING: 'api/lms/cancelTraining/',
    CANCEL_TRAINEE: 'api/lms/cancelTrainee/',
    ADD_TRAINEE: 'api/lms/addTrainee',
    UPDATE_TRAINEE: 'api/lms/updateTrainee',
    FINAL_UPDATE: 'api/lms/updateTrainingProgress',
    GET_VIEW_TRAINING: 'api/lms/getTrainingProgress/',

    REGISTER_TRAINER: 'api/lms/v2/registerForTrainer',
    GET_REGISTER_DETAILS: 'api/lms/v2/getRegisterTrainer/',
    ELIGIBLE_FOR_TRAINER: 'api/lms/eligibleForTrainer',
    UPDATE_REGISTER_FOR_TRAINER: 'api/lms/updateRegisterForTrainer'


};

export const HOME = {
    GET_ASSETS: 'api/home/getAssets/'
};
export const USER = {
    GET_ASSESSMENT_AGENCY_NAME_LIST: 'api/users/getInternalUsers/',
    SEARCH_USER: 'api/users/searchUser/v2',
    GET_MT_DLT_USER: 'api/lms/searchRegisterTrainer'

};

export const INC = {
    GET_INCUBATION_REPORT: 'api/inc/getIncubationReport',
    GET_INCUBATION_DETAILED_REPORT: 'api/inc/getIncubationDetailedReport'
};

export const GRIEVANCE = {
    GET_GRIEVANCE_ALL: 'api/grievances/getGrievances/page/',
    GET_GRIEVANCE_STATUS: 'api/grievances/getGrievances/page/1/',
    REPLY_TO_GRIEVANCE: 'api/grievances/replyToGrievance',
    GET_OLD_GRIEVANCE: 'api/grievances/getOldGrievance',
    GET_REPLY_BY_GRIEVANCE_ID: 'api/grievances/getReplyById/',
    GET_GRIEVANCES_BY_ID: 'api/grievances/getGrievancesById/',
    UPDATE_GRIEVANCE_DOCUMENTID: 'api/grievances/updateGrievanceDocumentId'


};

export const DIGITIZATION = {
    GET_DOCUMENT_DMS: 'api/digitization/getDocumentDMS/',
    GET_DOCUMENTATION_LIST: 'api/digitization/getDocumentList/',
    UPLOAD_DOCUMENT: 'api/digitization/uploadDocument/',
    UPLOAD_DOCUMENT_SUBSIDY: 'api/digitization/uploadSubsidyFileByFinTeam/',
    UPLOAD_DOCUMENT_SUBSIDY_NODAL: 'api/digitization/uploadSubsidyFileByNodalBank',
    VIEW_DOCUMENT_SUBSIDY: 'api/digitization/viewSubsidyDocumentDMS',
    VIEW_DOCUMENT_SUBSIDY_FINANCE: 'api/digitization/viewSubsidyDocumentDMSFinance',
    DELETE_DOCUMENT: 'api/digitization/deleteDocument',
    GET_LIST_DOCUMENT_DMS: 'api/digitization/getListDocumentDMS/',
    GET_SUBSIDY_DOCUMENT_DATA:'api/digitization/getSubsidyDocumentData',
    DELETE_SUBSIDY_DOCUMENT_DATA:'api/digitization/deleteSubsidyProcessFile',
};

export const DISBURSMENT = {
    GET_LOAN_DISBURSMENT_LIST: 'api/bankLinkage/getLoanDisbursementList',
    GET_LOAN_DETAILS: 'api/bankLinkage/getLoanDetails/',
    GET_NODAL_PROCESS_DATA: 'api/nodalBank/getNodalProcessedData',
    GET_LOAN_DISBURSMENT_LIST_V2: 'api/bankLinkage/getLoanDisbursementListV2',
    GET_LOAN_DISBURSMENT_LIST_V2_HO: 'api/bankLinkage/getLoanDisbursementListV2Ho',
    GET_TRANSIENT_DISBURSEMENT: 'api/master/getMasterBankTransientDetails'
};
export const SITE = {
    SAVE_MEDIA_DETAILS: 'api/site/saveSSMediaDetail/',
    EDIT_MEDIA_DETAILS: 'api/site/editSSMediaDetails/',
    GET_HOME_PAGE_INFO: 'api/site/getSSMediaDetails/',
    GET_CONTACT_DETAILS: 'api/master/getUsers',
    SAVE_OTHER_DETAILS: 'api/site/v2/saveSSMediaDetails',
    GET_DPR: 'api/site/getDpr/',
    SAVE_DPR: 'api/site/addDpr/',
    GET_DPR_PRODUCT: 'api/site/getDprProduct/',
    ADD_PRODUCT_DPR: 'api/site/addDprProduct',
    UPDATE_PRODUCT_DPR: 'api/site/editDprProduct',
    EDIT_DPR: 'api/site/editDpr/',
    EDIT_MEDIA_LINK_V2: 'api/site/v2/editSSMediaDetails'

};


export const BANKLINKAGE = {
    ACTION: 'api/bankLinkage/bankAction',
    BANK_ACTION_V2: 'api/bankLinkage/v2/bankAction',
    SAVE_ADDITIONAL_DOCUMENTS: 'api/master/saveAdditionalDocuments',
};
export const AIF = {
    GET_DETAILS_AIF: 'api/aif/getAifAppByAppId/',
    
};
export const APPROVAL = {
    GET_APPLICATION_LIST_NON_IND: 'api/approval/getApplicationListNonInd',
    GET_APPROVAL_HISTORY: 'api/approval/getApprovalHistory/',
    SAVE_APPROVAL_INFO_NON_IND: 'api/approval/saveApprovalInfoNonInd'
};

export const REPORTTAB = {
    STATE_TAB: 'State',
    BANK_TAB: 'Bank'
};

export const APPROVAL_TAB = {
    ALL: 'all',
    NEW: 'new',
    UNDER_PROCESS: 'under_process',
    FAILED: 'failed'
};

export const KPI = {
    GET_LENDING_BANK_REPORT: 'api/kpi/getLandingBankReport',
    GET_LENDING_BANK_REPORT_V2: 'api/kpi/getLandingBankReportV2',
    GET_LENDING_BANK_REPORT_V3: 'api/kpi/getLandingBankReportV3',
    GET_KPI_REPORT: 'api/kpi/getKpiReport',
    GET_KPI_REPORT_BANK: 'api/kpi/getKpiReportBank',
    GET_SOCIAL_CATEGORY_GRAPH_: 'api/kpi/getSocialCategoryGraph',
    GET_SUBSIDY_COUNT: 'api/digitization/getCountsOfSubsidy',
    GET_ODOP_GRAPH_DETAILS: 'api/kpi/getOdopGraphDetails',
    GET_GENDER_GRAPH_DETAILS: 'api/kpi/getGenderGraphDetails',
    GET_APPROVED_ODOP_GRAPH_DETAILS: 'api/kpi/getApprovedOdopGraphDetails',
    GET_KPI_APPLICATION_CATEGORY: 'api/kpi/getKpiApplicationCategory',
    GET_TOP_TEN_PRODUCT_GRAPH_DETAILS: 'api/kpi/getTopTenProductGraphDetails',
    GET_PERIOD_WISE_GRAPH_DETAILS: 'api/kpi/getPeriodWiseGraphDetails',
    GET_KPI_LENDING_BANK_COUNT: 'api/kpi/v1/getKpiLendingBankCount',
    GET_KPI_APPLICATION_APPROVAL_DAYS: 'api/kpi/getKpiApplicationApprovalDays',
    GET_GREIVANCE_GRAPH_DETAILS: 'api/kpi/getGreivanceGraphDetails',
    GET_STATE_RANK: 'api/kpi/getSanctionedApplicationRankDetails',
    GET_INDIVIDUAL_APPLICATION: 'api/kpi/getFinancialYearWiseKpiCount',
    GET_SNA_CONTACT_DETAILS: 'api/home/getSnaContactDetails',
    GET_NRLM_DASHBOARD_DATA: 'api/kpi/getAllKpiCountByNrlmOrNulmDashBoardV1',
    GET_CONVERGENCE_PARTNER: 'api/users/getConvergencePatnerCategory',
    GET_NPMU_FINANCE_REPORT: 'api/digitization/getSubsidyDocumentsListUploadedByFinTeam',
    SEND_NPMU_FINANCE_REPORT: 'api/digitization/sendSubsidyDocumentToNodalBank/',
    RETURN_BATCH_FILE_TO_NPMU: 'api/digitization/returnSubsidyFile',
    GET_SUBSIDY_NODALBANK_REPORT: 'api/digitization/getSubsidyDocumentsListUploadedByNodalBank',
    ADD_NPMU_REMARKS: 'api/digitization/addRemakByFincaeTeam',
    GET_DRP_LIST: 'api/mis/getDrpDlcList',
    DOWNLOAD_DRP_LIST: 'api/mis/downloadDrpDlcList',
    GET_STATE_KPI_COUNT: 'api/kpi/getStateWiseKpiCount',
    DOWNLOAD_STATE_WISE_KPI_COUNT: 'api/kpi/downloadStateWiseKpiCount',
    GET_WEEKLY_KPI_COUNT: 'api/kpi/getAllKpiCountByWeekWise',
    GET_BANK_KPI_COUNT: 'api/kpi/getBankKpi1Count',
    GET_TOP_STATE_KPI_COUNT: 'api/kpi/getStateRank',
    DOWNLOAD_WEEKLY_REPORT_KPI: 'api/kpi/downloadWeekWiseKpiCount',
    DOWNLOAD_YEARLY_REPORT_KPI: 'api/kpi/downloadFinancialYearWiseKpiCount',
    DOWNLOAD_TOP_STATE_REPORT_KPI: 'api/kpi/downloadStateRankKpiCount',
    GET_BANK_STATE_KPI: 'api/kpi/getStateWiseBankKpi2Count',
    GET_BANK_DISTRICT_KPI: 'api/kpi/getDistrictWiseBankKpi3Count',
    GET_APPLICATION_DETAILS_KPI: 'api/kpi/getAllDistrictApplicationsList',
    GET_FINANCIAL_APPLICATION_DETAILS_KPI: 'api/kpi/getApplicationFinancialDetails/',
    GET_STATE_WISEBANK_PENDENCY_COUNT: 'api/kpi/getStateWiseBankPendencyCount',
    GET_DISTRICT_WISEBANK_PENDENCY_COUNT: 'api/kpi/getDistrictWiseBankPendencyCount',
    GET_BANK_WISE_SANCTION: 'api/kpi/getBankWiseSanctionApplicationStatus',
    GET_STATE_WISE_SOCIAL_CATEGORY: 'api/kpi/getStateWiseSocialCategoryCount',
    DOWNLOAD_BANK_WISE_SANCTION: 'api/kpi/downloadBankWiseSanctionApplicationStatus',
    DOWNLOAD_BANK_WISE_PENDENCY: 'api/kpi/downloadStateWiseBankPendencyReport',
    GET_DISTRICT_WISEBANK_PENDENCY_BYDURATION: 'api/kpi/getBankPendingApplicationsByDuration',
    GET_STATE_WISE_SOCIAL_CATEGORY_BYDURATION: 'api/kpi/getApplicationsSocialCategoryWise',
    DOWNLOAD_DFS: 'api/kpi/downloadKpiCountForDfs',
    DOWNLOAD_DFS_FOR_BANKWISE: 'api/kpi/downloadKpiCountForDfsBankWise',
    SUBSIDY_REPORT: 'api/kpi/getIndAppDetailsWithPan',
    SUBSIDY_REPORT_NON_IND: 'api/kpi/getNonIndAppDetailsWithPan',
    DOWNLOAD_SUBSIDY_REPORT_NON_IND: 'api/kpi/downloadNonIndAppDetailsWithPan',
    DOWNLOAD_SUBSIDY_REPORT_IND: 'api/kpi/downloadIndAppDetailsWithPan',

};

export const COMMON = {
    SEND_OTP: 'api/common/sendOtp',
    SEND_BOTH_OTP: 'api/users/sendOtpForVerifyInternalUserContactDetails',
    VALIDATE_BOTH_OTP: 'api/common/validateBothOtp',
    VALIDATE_OTP: 'api/common/validateOtp',
    GET_APPLICATION_DETAILS: 'api/common/getApplicationDetails',
    GET_APPLICATION_DETAILS_V2: 'api/common/v2/getApplicationDetails',
    DOWNLOAD_LANDING_BANK_REPORT: 'api/common/downloadLandingBankReport',
    DOWNLOAD_FORMALISATION_REPORT: 'api/reports/getFormalisedDataReport',
    GET_FORMALISATION_DATA: 'api/projectMonitoring/getFormalisedData',
    DOWNLOAD_LANDING_BANK_REPORT_GROUP: 'api/common/downloadBankReport_NonIndividual',
    DOWNLOAD_REPORT: 'api/common/downloadReport',
    DOWNLOAD_REPORT_NON_IND: 'api/common/downloadReportNonInd',
    SEARCH_APPLICATION: 'api/common/searchApplication/',
    GET_LAST_BUILD_AND_RELEASES: 'api/mis/getLatestBuildAndReleases',
    GET_UPLOADED_DOCUMENT: 'api/digitization/getDocumentList/',
    SAVE_DETAILS_OF_USER: 'api/users/saveBankInternalUserMang',
    GET_SANCTIONED_BUT_NOT_DISBURSED_DATA: 'api/reports/getNotAbleToBeDisbursedDetails',
    GET_SANCTIONED_BUT_NOT_DISBURSED_DATA_HO: 'api/reports/getNotAbleToBeDisbursedDetailsHo',
    DOWNLOAD_SANCTIONED_BUT_NOT_DISBURSED_DATA: 'api/reports/getNotAbleToBeDisbursedData',
    INTERNAL_SOURCING_DATA: 'api/users/saveInternalSourcingUser',
    GET_INTERNAL_SOURCINGBY_DISTICT: 'api/users/getInternalSourcingUserByDistrict/',
    GET_INTERNAL_SOURCINGBY_USERID: 'api/users/getInternalSourcingUserById/',
    INTERNAL_SOURCING_DATA_REGISTER: 'api/users/v4/registerUser',
    CREATE_ZONE_USER: 'api/users/createZoneUsers',
    GET_ZONE_USER: 'api/users/getZoneUsers',
    UPDATE_ZONE_USER: 'api/users/updateZoneUsers',


};

export const SECTION = {
    APP: 'Application',
    DOC: 'Document',
    HIS: 'Historical',
    FIN: 'Financial',
    PRO: 'Project',
    UPB: 'Update-status-bank-linkage',
    UPI: 'Update-status-ind',
    DAN: 'DRP Appraisal Note',
    APPROVAL: 'Approval'
};

export const APPLICATION = {
    GET_APPLICATION_LIST_IND: 'api/application/getApplicationListInd',
    GET_APPLICATION_LIST_IND_V2: 'api/application/getApplicationListInd/v2',
    GET_APPLICATION_LIST_IND_V3: 'api/application/getApplicationListInd/V3',
    GET_APPLICATION_LIST_IND_AIF: 'api/kpi/getStateWiseBulkDataForSanctioned',
    GET_APPLICANT_ID: 'api/application/getApplicantId/',
    GET_APPLICANT_ID_V2: 'api/application/v2/getApplicantId/',
    GET_EXISTING_ENTERPRISE_DETAILS: 'api/application/getExistEnterpriseDetails/',
    GET_EXISTING_ENTERPRISE_DETAILS_V2: 'api/application/v2/getExistEnterpriseDetails/',
    GET_PROPOSAL_DETAILS: 'api/application/getProposalDetails/',
    GET_PROPOSAL_DETAILS_V2: 'api/application/v2/getProposalDetails/',
    GET_PROPOSED_FINANCIAL_DETAILS: 'api/application/getProposedFinancialDetails/',
    GET_LT1CR_EXIST_FINANCIAL_DETAILS: 'api/application/getLt1crExistFinancialDetails/',
    GET_MT1CR_EXIST_FINANCIAL_DETAILS: 'api/application/getMt1crExistFinancialDetails/',
    GET_PROJECTED_FIN: 'api/application/getProjectedFin/',
    SAVE_DRP_DETAILS: 'api/application/saveDrpDetails',
    VIEW_REPLY: 'api/application/viewReply/',
    GET_DRP_DETAILS: 'api/application/getDrpDetails/',
    SAVE_APPROVAL_FO_IND: 'api/application/saveApprovalInfoInd',
    GET_APPROVAL_DETAILS: 'api/application/getApprovalDetails/',
    GET_LANDING_BANK_DETAILS: 'api/master/getLandingBankDetails',
    GET_SAME_BRANCH_LANDING_BANK_DETAILS: 'api/master/getLendingBankDetails',
    GET_APPLICATION_LIST_NON_IND: 'api/application/getApplicationListNonInd',
    GET_DRP_DETAILS_V2: 'api/application/getDrpDetails/v2/',
    SAVE_DRP_DETAILS_V2: 'api/application/saveDrpDetails/v2',
    GET_OTHER_ODOP_PDT: 'api/master/getOdopOtherProduct/',
    GET_ODOP_PRODUCT: 'api/master/getOdopProduct/districtCode/',
    GET_LENDING_BANK: 'api/application/getLendingBankDetails/',
    SAVE_CONTACT_DETAILS_SNA: 'api/home/saveSnaContactDetails',
    DELETE_CONTACT_DETAILS_SNA: 'api/home/deleteSnaContactDetails',


};

export const FUND_MONITORING = {
    GET_FUND_MONITORING_REPORTS: 'api/reports/getFundMonitoringReports',
    GET_LOAN_RELEASE_LIST: 'api/fundMonitoring/getLoanReleaseListV1',
    GET_LOAN_REPAYMENT_DETAILS: 'api/fundMonitoring/getLoanRepaymentDetails/',
    SEARCH_LOAN_REPAYMENT: 'api/fundMonitoring/searchLoanRepayment',
    GET_LAON_REPAYMENT_LIST: 'api/fundMonitoring/getLoanRepaymentList/',
    SAVE_LOAN_REPAYMENT_DETAILS: 'api/fundMonitoring/saveLoanRepaymentDetails',
    GET_PROGRESS_DETAILS: 'api/fundMonitoring/getProgressDetails/',
    SAVE_PROGRESS_DETAILS: 'api/fundMonitoring/saveProgressDetails',
    GET_PROGRESS_VIEW_DETAILS: 'api/fundMonitoring/getProgressViewDetails',
    GET_VIEW_IMP_DETAILS: 'api/fundMonitoring/getViewImplementationDetails',
    GET_MEASURING_DICATOR_IMP_PHASE: 'api/fundMonitoring/v1/getMeasuringDicatorsImplPhase/',
    SAVE_MEASURING_DICTOR_IMP_PHASE: 'api/fundMonitoring/v1/saveMeasuringDicatorsImplPhase',
    GET_OUTSTANDING_STATUS: 'api/fundMonitoring/getOutstandingStatus',
    GET_LOAN_OUTSTANDING_STATUS: 'api/fundMonitoring/getFundMonitoringReport',
    GET_LOAN_DEFAULTERS: 'api/fundMonitoring/getLoanDefaulterReport',
    GET_LOAN_SANCTION_REJECTION: 'api/fundMonitoring/getLoanSanctionRejectionReport',
    GET_CERTIFICATION_STANDARD_ACHIEVED: 'api/fundMonitoring/getCertificationsStandardAchievedReport',
    DELETE_APPLICATION: 'api/fundMonitoring/deleteApplication',
    REQUEST_CHANGE_FORMALISATION_SNA: 'api/fundMonitoring/snaAction',
    GET_FORMALISATION_HISTORY: 'api/fundMonitoring/getFormalizationChanges/',

};

export const APPLICATION_VIEW = {
    LT_1CR_HISTORICAL_FINANCIAL_DETAILS: 'api/applicationView/lT1CRHistoricalFinancialDetails/',
    MT_1CR_HISTORICAL_FINANCIAL_DETAILS: 'api/applicationView/mT1CRHistoricalFinancialDetails/',
};

export const MASTER_CONTROLLER = {
    GET_APPLICANT_CAST: 'api/master/getApplicantCast',
    GET_GENDER: 'api/master/getGender',
    GET_STATE: 'api/master/getStates',
    GET_DISTRICT: 'api/master/getDistricts/',
    GET_STATE_LIST_ZO: 'api/bankLinkage/getStateListForZo',
    GET_DISTRICT_LIST_ZO: 'api/bankLinkage/getDistrictListForZo',
    GET_REQUESTED_REPORT: 'api/summeryReport/getReportRequestList',
    GET_REQUESTED_REPORT_ADDITIONAL_BANK: 'api/summeryReport/getReportRequestDataListV1/AdditionalDocumentReportV2',
    GET_REQUESTED_REPORT_SANCTION_PENDENCY: 'api/summeryReport/getReportRequestDataListV1/SanctionPendencyReportV2',
    GET_APPLICANT_CATEGORY: 'api/master/getApplicantsCategory',
    GET_SUBCATEGORY: 'api/master/getAppSubCategory/',
    VIEW_REPORT: 'api/application/viewReportDetails',
    REPORT_REQUEST: 'api/summeryReport/getLandingBankReportV5',
    SANCTION_PENDENCY_REPORT_REQUEST: 'api/summeryReport/getSanctionPendencyV2',
    DOWNLOAD_REPORT: 'api/reports/getViewExcelReport',
    DOWNLOAD_REQUESTED_BANK_REPORT: 'api/summeryReport/downloadBankReport/',
    DOWNLOAD_SANCTION_REPORT: 'api/summeryReport/downloadSanctionPendencyReportV2/',
    DOWNLOAD_REQUESTED_ADDITIONAL_BANK_REPORT: 'api/summeryReport/downloadAdditionalDocumentRequiredReportV2/',
    DOWNLOAD_REPORT_IND: 'api/reports/getReportByApplicantId/',
    DOWNLOAD_REPORT_MT1CR: 'api/reports/getMoreThan1CRReportByApplicantId/',
    DOWNLOAD_REPORT_LT1CR: 'api/reports/getLessThan1CRReportByApplicantId/',
    DOWNLOAD_REPORT_SHG: 'api/reports/getSHGReport/',
    GET_APPLICATION_STATUS_REPORT: 'api/reports/getApplicationStatusReport/',
    GET_REPORT_BY_APPLICANT_ID_VER_NEW: 'api/reports/getOnlineReportType/',
    GET_TIME_FRAME: 'api/master/getRepayTimeFrameList/',
    GET_DOC_DMS: 'api/digitization/getDocumentDMS',
    GET_ODOP_PRODUCT_SEARCH: 'api/master/getOdopProductSearch',
    GET_INSTITUTE: 'api/master/getInstitute',
    GET_MASTER_TRAINING_LIST: 'api/master/getMasterTrainingList',
    GET_MASTER_PRODUCT_CODE_LIST: 'api/master/getMasterProductCodeList',
    GET_DLT_MLT: 'api/users/getMtDltUsers/',
    GET_INCUBATION_CENTRE: 'api/master/v2/getIncubationCenter/stateCode/',
    GET_INCUBATION_CENTRE_NEW: 'api/inc/getIncubationCenter/',
    GET_ONLINE_REPORT_TYPE: 'api/reports/getOnlineReportType/',
    GET_DOCUMENTATION_LIST: 'api/digitization/getDocumentList/',
    GET_DOCUMENT_DMS: 'api/digitization/getDocumentDMS/',
    GET_SANCTIONED_APPLICATIONS: 'api/application/getApplicationDetails',
    SAVE_LAT_LONG: 'api/application/saveLatLong',
    DOWNLOAD_AIF_REPORT: 'api/kpi/downloadStateWiseBulkDataForSanctioned',


};

export const BANK_LINKAGE = {
    SAVE_BASIC_DIUSBURSMENT_DETAIL: 'api/bankLinkage/saveBasicDisbursementDetails',
    SAVE_LOAN_DISBURSEMENT_DETAIL: 'api/bankLinkage/saveLoanDisbursementDetails',
    GET_SANCTIONED_APPLICATIONS: 'api/bankLinkage/getLoanDisbursementPendingListV2',
    GET_REJECTION_REASON_LIST: 'api/bankLinkage/getReasonList',
    REJECT_AFTER_SANCTION: 'api/bankLinkage/sanctionButNotDusbursement',
    GET_LOAN_DISBURSEMENT: 'api/bankLinkage/getLoanDisbursementDetails',
    GET_INTERNAL_SOURCING_USER_LIST: 'api/kpi/getInternalSourcingUser',
    GET_SUBVENTION_LIST: 'api/bankLinkage/getSubventionScheme',
    GET_APPLICATIONS_SUBSIDY: 'api/bankLinkage/getApplicatiosToCreateBatchFoSubsidy',
    SAVE_BATCH: 'api/bankLinkage/saveBatchV1',
    GET_BATCHES: 'api/bankLinkage/getBatchesV1',
    GET_BATCHES_FOR_REPORT: 'api/mis/grantsSubsidyFileDownloadList',
    RELEASE_SUBSIDY: 'api/bankLinkage/releaseSubsidyV1',
    GET_BATCH_DETAILS: 'api/bankLinkage/getBatchDetails',
    REMOVE_APPLICATION_BATCH: 'api/bankLinkage/removeApplicationBatchV1',
    GET_BANK_LOAN_STATUS_DETAILS: 'api/bankLinkage/getBankLoanStatusDetails/',
    GET_SEARCH_APP_DETAILS: 'api/bankLinkage/getSearchAppDetails',
    DOWNLOAD_SEARCH_APP_DETAILS: 'api/kpi/downloadAxisBankUserDetails',
    ROLL_BACK_DECISION: 'api/bankLinkage/rollbackDecision',
    APPLICATIONS_FOR_HO_VERIFICATION: 'api/bankLinkage/disburseApplicationlistHoV1',
    APPLICATIONS_FOR_HO_DELEGATION: 'api/bankLinkage/delegatedApplicationListByHoV1',
    APPLICATIONS_FOR_HO_BUCKET: 'api/bankLinkage/varificationPendingHoV1',
    APPLICATIONS_FOR_ZO_VERIFICATION: 'api/bankLinkage/disburseApplicationlistZo',
    VERIFY_HO_APPLICATION: 'api/bankLinkage/disburseHoVerify',
    APPLICATION_TO_SHIFT: 'api/application/getBankPendingApplicationList',
    GET_BANK_SANCTION_DATA: 'api/kpi/getBankWiseSanctionStatusForDfs',
    GET_BANK_ADDED_USER_DATA: 'api/users/getAxisBankUserDetails',
    GET_GATI_SHAKTI: 'api/kpi/getApplicantDetailsForPmGatiSakti',
    GET_STATEWISE_SENT_TO_BANK: 'api/approval/getStateWiseSTBCount',
    SUBSIDY_PAYMENT_REPORT: 'api/bankLinkage/paymentDetailsList',
    GET_WITHDRWAN_APPLICATION: 'api/mis/getWithdrawnApp',
    GET_BANKWISE_REJECTED: 'api/bankLinkage/getBankWiseRejectCount',
    GET_BANKWISE_PENDING: 'api/bankLinkage/bankWisePendingCount',
    GET_STATEWISE_REJECTED: 'api/bankLinkage/getStateWiseRejectCount',
    GET_STATEWISE_PENDING: 'api/bankLinkage/stateWisePendingCount',
    GET_STATEWISE_SANCTIONED: 'api/kpi/getSenctionedDetailsStateWise',
    GET_BANKWISE_SANCTIONED: 'api/kpi/getSenctionedDetailsBankWise',
    GET_BANKWISE_SENTTOBANK: 'api/kpi/getApprovalCounts',
    GET_BRANCH_DETAILS: 'api/bankLinkage/getBankList',
    DOWNLOAD_BANK_BRANCH_DETAILS: 'api/reports/getDownloadBankBranchReport',
    GET_SANCTIONED_BUT_NOT_DISBURSED_REPORT_DATA: 'api/kpi/getAppDetailsForStatusSancButNotAbleToDisburse',
    GET_SANCTIONED_PENDENCY_DATA: 'api/kpi/getAppDetailsForStatusPendingWithLendingBank',
    DOWNLAOD_SANCTIONED_BUT_NOT_DISBURSED_REPORT_DATA: 'api/kpi/downloadAppDetailsForStatusSancButNotAbleToDisburse',
    GET_ADDITIONAL_DOCUMENT_REQUIRED_REPORT_DATA: 'api/kpi/getApplicantDetailsForStatusAddDocRequired',
    GET_PENDING_WITH_BANK_REPORT_DATA: 'api/kpi/getAppDetailsForStatusLoanSanctioned',
    GET_ADDITIONAL_REPORT_BANK_DATA: 'api/summeryReport/getAdditionalDocumentRequiredReportV2',
    DOWNLOAD_BANK_SANCTION_DATA: 'api/kpi/downloadBankWiseSanctionStatusForDfs',
    DOWNLOAD_GATI_SHAKTI_DATA: 'api/kpi/downloadAppDetailsForPmGatiSakti',
    DOWNLOAD_STATEWISE_SENT_TO_BANK_DATA: 'api/reports/getStateWiseSTBCountReport',
    DOWNLOAD_SUBSIDY_PAYMENT_REPORT: 'api/reports/paymentDetailsReport',
    DOWNLOAD_WITHDRWAN_APPLICATION_DATA: 'api/mis/downloadWithdrawnApp',
    DOWNLOAD_BANKWISE_REJECTED: 'api/reports/getBankWiseRejectCountReport',
    DOWNLOAD_BANKWISE_PENDING: 'api/reports/bankWisePendingCountReport',
    DOWNLOAD_STATEWISE_REJECTED: 'api/reports/getStateWiseRejectCountReport',
    DOWNLOAD_STATEWISE_PENDING: 'api/reports/stateWisePendingCountReport',
    DOWNLOAD_STATEWISE_SANCTIONED: 'api/reports/downloadSenctionedDetailsStateWise',
    DOWNLOAD_BANKWISE_SANCTIONED: 'api/reports/downloadSenctionedDetailsBankWise',
    DOWNLOAD_BANKWISE_SENTTOBANK: 'api/kpi/downloadApprovalCounts',
    DOWNLOAD_PARKED_DATA: 'api/kpi/downloadAppDetailsForStatusSancButNotAbleToDisburse',
    DOWNLOAD_SANCTION_PENDENCY_DATA: 'api/kpi/downloadAppDetailsForStatusPendingWithLendingBank',
    DOWNLOAD_ADDITIONAL_DOCUMENT_REQUIRED_DATA: 'api/kpi/downloadAppDetailsForStatusAddDocRequired',
    DOWNLOAD_DISBURSEMENT_PENDING_DATA: 'api/kpi/downloadAppDetailsForStatusLoanSanctioned',
    DOWNLOAD_INTERNAL_SOURCING_USER_LIST: 'api/kpi/downloadInternalSourcingUser',
    GET_STATE_SANCTION_DATA: 'api/kpi/getStateWiseSanctionStatusForDfs',
    DOWNLOAD_STATE_SANCTION_DATA: 'api/kpi/downloadStateWiseSanctionStatusForDfs',
    GET_BANKWISE_APPLICATION_STATUS: 'api/kpi/getBankWiseStatusReport',
    GET_MONTHLY_APPLICATION_STATUS: 'api/kpi/downloadMonthlyApplicantDetails',
    DOWNLOAD_BANKWISE_APPLICATION_STATUS: 'api/kpi/downloadBankWiseStatusReport',
    GET_CONVERSION_PARTNER_REPORT: 'api/reports/getApplicationStatusReportV2',
    GET_PULLBACK_DOCUMENT: 'api/bankLinkage/pullBackAddDocRequired',
    GET_BANK_TYPE_AND_BANK: 'api/mis/getBankTypeAndBank',
    ZONAL_NAME_SAVE: 'api/bankLinkage/saveZonalOffice',
    GET_ZONAL: 'api/bankLinkage/getZonalOffice',
    ZONE_USER_STATE_DISTRICT: 'api/bankLinkage/saveZoneStateDistrictMapping',
    GET_ZONE_STATE_LIST: 'api/bankLinkage/getZoneStateDistrictMapping',
    UPDATE_ZONE_USER_STATE_DISTRICT: 'api/bankLinkage/updateZoneStateDistrictMapping',
    DELETE_AREA_AND_STATE: 'api/bankLinkage/deleteZoneStateDistrictMapping',
    DELETE_ZONAL_OFFICE: 'api/bankLinkage/deleteZonalOffice',
     APPLICATIONS_FOR_HO_BUCKET_VARIFY: 'api/bankLinkage/disburseVerifiedAppInBatch',
    DOWNLOAD_ZONE_REPORT: 'api/bankLinkage/getZoneDetailsWithUserArea',
    GET_ALL_VERIFICATION_Application: 'api/bankLinkage/allBankDisburseApplicationList',
    DOWNLOAD_ALL_VERIFICATION_Application: 'api/bankLinkage/allBankDisburseApplicationList',
    GET_ALL_VERIFICATION_PENDING_Application: 'api/bankLinkage/getPendingToVerifyApplications',
    GET_BATCH_PROGRESS_STATUS: 'api/bankLinkage/getBatchProgress',
   
    GET_HO_REPORT_APPLICATION: 'api/mis/getHoReportList',
    

};

export const REPORT_VIEW = {
    GET_LENDING_BANK_DETAILED_REPOST: 'api/reports/getLendingBankDetailedReport',
    DOWNLOAD_LENDING_BANK_REPORT_V2: 'api/kpi/downloadLandingReportV2',
    DOWNLOAD_LENDING_BANK_REPORT_V2_NEW: 'api/summeryReport/getLandingBankReportV4',
    DOWNLOAD_LENDING_BANK_REPORT_V3: 'api/kpi/downloadLandingReportV3',
    GET_DB_PRODUCT_PROPOSED_REP: 'api/reports/getDBProductProposedRep',
    GET_DB_EXT_PROPOSED_REP: 'api/reports/getDBExtProposedRep',
    GET_DB_APP_FIN_REPORT: 'api/reports/getDBApplicantFinRep',
    GET_DB_DEFFICIENCY_LETTER_DLC_REPORT: 'api/reports/getDBDiffeciencyLetterDLCRep',
    GET_DB_STATEWISE_APPLICATION_DLC_REPORT: 'api/reports/getDBStateWiseApplicationDLCRep',
    GET_DB_BANK_APPR_APPLICATION_REPORT: 'api/reports/getDBBankApprovedApplicationCRep',
    GET_DB_SUBSIDY_AMT_NT_SUBMIT_STATE_REPORT: 'api/reports/getDBSubsidyAmtNotSubmitedByStateCRep',
    GET_DB_LOAN_REJECTED_BOTH_BANK: 'api/reports/getDBLoanRejectedByBothBankRep',
    GET_DB_LOAN_APPROVED_SECOND_BANK: 'api/reports/getDBLoanAmtApprovedBySecBankRep',
    GET_DB_GRIEVANCE_RESOLVED_ISSUES_REP: 'api/reports/getDBGrievanceResolvedIssuesRep',
    GET_DB_BENEFICIARY_LOAN_TRACKING: 'api/reports/getDBBeneficiaryLoanTrackingRep',
    GET_DB_DRP_PERFORMANCE_REPORT: 'api/reports/getDBDRPPerformanceReportRep',
    GET_DB_GRIEVANCE_NOT_RESOLVED_NO_ACTION: 'api/reports/getDBGrievanceNotResolvedIssuesRep',
    GET_USER_LOGIN_DETAIL: 'api/reports/getUserLoginDetailReport',
    GET_DB_DEFFIECIENCY_LETTER_STATE_REPORT: 'api/reports/getDBDiffeciencyLetterStateRep',
    DOWNLOAD_HO_VERIFICATION_REPORT: 'api/reports/getDownloadHoVerificationExcelReportV1',
    DOWNLOAD_SUBSIDY_REPORT: 'api/mis/grantsSubsidyDownloadExcelSheet',
  DOWNLOAD_HO_VERIFICATION_REPORT_IN_BATCH: 'api/reports/downloadDisburseVerifiedAppInBatch',
 DOWNLOAD_ALL_VERIFICATION_Application : 'api/reports/getDownloadAllBanksHoVerificationExcelReport',
    DOWNLOAD_ALL_PENDING_VERIFICATION_Application : 'api/reports/getPendingToVerifyApplicationsExcelReport',
    DOWNLOAD_HO_REPORT_APPLICATION: 'api/reports/downloadHoReportList',

};


    export const PROJECT_MONITORING = {
        APPLICATION_SUBMITTED: 'api/projectMonitoring/getProjectMonitoringAppSubmitted',
        APPROVED_GRAPH: 'api/projectMonitoring/getApplicationApprovedGraph',
        APPROVED_BANK: 'api/projectMonitoring/getBankApplicationApproved',
        TOTAL_SUBSIDY: 'api/projectMonitoring/getTotalSubsidyDisbursed',
        GET_BENEFICIARY: 'api/projectMonitoring/getBeneficiaryStatusReport',
        GET_GRIEVANCE_COUNT: 'api/projectMonitoring/getGrievaneCountReport',
        GET_BENEFICIARY_SALES_REPORT: 'api/projectMonitoring/getBeneficiarySalesReport'
    };

    export const PIP_VIEW = {
        PLANNING_AND_DATA_COLLECTION: 'api/pip/planningAndDataCollection/',
        PROMOTIONAL_ACTIVITY: 'api/pip/promotionalActivity/',
        STAFFING_ACTIVITY: 'api/pip/staffingAndRecruitment/',
        SLT_PLAN: 'api/pip/sltiPlan/',
        GET_ALL_PIP: 'api/pip/getAllPIP/',
        SAVE_TRAINING_BUDGET: 'api/pip/trainingBudget/',
        SAVE_SUBSIDY_DISBURSEMENT_BUDGET: 'api/pip/subsidyDisbursementBudget/',
        SAVE_BRAND_MARKETING: 'api/pip/brandingMarketing/',
        SAVE_OTHER_ITEM: 'api/pip/otherItems/',
        SUBMIT_PIP: 'api/pip/submitPIP',
        GET_DECISION_LIST: 'api/master/getDecisionList',
        SAVE_HAND_HOLDING: 'api/pip/handHoldingSupport/',
        SUBMIT_REMARK: 'api/pip/pipDecision'


    };


    // getLendingBankDetailedReport

    export const PAGINATION_PARAMETERS = {
        PAGE: 1,
        PAGE_SIZE: 10
    };

    export const PATTER_VALIDATION = {
        NAME: '^([a-zA-Z ]){2,30}$',
        TRAINING_DES: '^([a-zA-Z ]){2,500}$',
        PROD_NAME: '^([a-zA-Z ]){2,100}$',
        PHONE: '^[0-9]{1,25}$',
        STRICT_PHONE: '^[0-9]{10}$',
        USER_SEARCHBY: '^([a-zA-Z ]){2,80}$',
        //EMAILL: '[a-zA-Z0-9.-]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}',
        // EMAILL: '[a-z0-9._!#$%&*-+]+@[a-z0-9.-]+\.[a-z]{2,4}$',
        EMAIL: '[a-z0-9_!#$%&*+.-]+@[a-z0-9.-]+\.[a-z]{2,4}$',
        DIGI10TPHONE: '^[0-9]{1,11}$',
        DIGI15TPHONE: '^[0-9]{1,15}$',
        TRANSIENT_ACCOUNT: '^[0-9]{16}$',
        DIGI5LIMIT: '^[0-9]{1,5}$',
        DIGI4LIMIT: '^[0-9]{1,4}$',
        DIGI3LIMIT: '^[0-9]{1,4}$',
        CLASS_SIZE: '^[0-9]{1,6}$',
        DIGI10TPHONENO: '[0-9]{10}$',
        ALPHA: '[a-zA-Z0-9.-]{1,11}$',
        ALPHA1: '[a-zA-Z]{3,80}$',
        PAN: '[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}',
        GST: '([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([a-zA-Z]){1}([0-9A-Z]){1}$',
        FSSAI: '[0-9]{14}',
        APPLICANT_NUMBER: '[0-9]{5}',
        UDYOG_AADHAR: '[a-zA-Z]{2}[0-9]{2}[a-zA-Z]{1}[0-9]{7}',
        UDYOG_REGISTRATION_NUMBER: '[a-zA-Z]{5}[-]{1}[a-zA-Z]{2}[-]{1}[0-9]{2}[-]{1}[0-9]{7,8}',
        NUMBER_DECIMAL: '^[0-9]*(\.[0-9]{1,2})?$',
        ALPHA_NUMERIC: '^[a-zA-Z0-9]+$',
        NUMBER: '^[0-9]{0,9}$',
        URL: '^(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$',
        EMAILV2: '[a-zA-Z0-9_!#$%&*+.-]+@[a-z0-9.-]+\.[a-z]{2,4}$',
        PERCENTAGE: '(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)',
        URL_SITE_SUBSITE: '^(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$',
        PIN: '[0-9]{6}$',
        EXP: '[0-9]{1,2}$',
        MOBILE_NO: '[0-9]{10}$',
        IFSC: '^[A-Za-z]{4}0[A-Z0-9]{6}$',
        MICR: '^[0-9]{9}$',
        City: '^[A-Za-z ]+$',
        APPNUM: '^[0-9]{5,}$',
        AADHAR: '[0-9]{12}$',
        ACCOUNTNUMBER: '[0-9]{9,18}$',
        latiLongi: '[0-9]{2}[.]{1}[0-9]{3,10}$',
        ALPHA_SPACE: '^([a-zA-Z ]){3,30}$',
        PASSWORD_VALIDATION: /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,16}$/,


    };


    export const ADMIN_SUPPORT = {
        SEARCH_MASTER_BANK: 'api/mis/getBankNameList',
        ADD_MASTER_BANK: 'api/mis/saveBankName',
        ADD_BANK_BRANCH: 'api/mis/saveMasterBank',
        UPDATE_MASTER_BANK: 'api/mis/updateBankName/',
        UPDATE_BANK_BRANCH: 'api/mis/updateMasterBank/',
        UPDATE_TRANSIENT_ACCOUNT: 'api/mis/updateTransientDetails/',
        REMOVE_SANCTION_DETAILS: 'api/mis/updateLoanSanctionDetails/',
        GET_LANDING_BANK_DETAILS1: 'api/mis/getLandingBankDetails/',
        GET_SINGLE_APPLICATION_DATA_TO_SHIFT: 'api/application/getSearchAppDetails/',
        GET_APPLICATION_DETAILS: 'api/mis/searchApplication/',
        SWIPE_LENDING_BANK: 'api/mis/swapeLendingBank/',
        GET_MEDIA_DESCRIPTION: 'api/home/getMediaDescription',
        SAVE_MEDIA: 'api/home/saveHomeMediaDetails',
        GET_MEDIA_DETAILS_TO_PUBLISH: 'api/home/getHomeMediaDetailsToBePublished',
        PUBLISH_MEDIA: 'api/home/publishHomeMediaDetails',
        GET_WHOS_WHO_CATEGORY: 'api/home/getWhosWhoType',
        GET_WHOS_WHO_DESIGNATION: 'api/home/getMasterDesignation',
        SAVE_WHOS_WHO: 'api/home/saveWhosWhoDetails',
        PUBLISH_WHOS_WHO: 'api/home/publishHomeWhosWhoDetails',
        SMS_DATA: 'api/mis/getSentSmsRecord',
        GET_WHOS_WHO_TO_PUBLISH: 'api/home/getWhoWhoDetailsToBePublished',
        KPI_ALL_DATA: 'api/kpi/kpiSubmittedProposal',
        KPI_DATA_DISTRICT: 'api/kpi/kpiReportDistrictWise',
        GET_ASSETS: 'api/home/getAssets/',
        GET_BUILD_AND_RELEASES: 'api/mis/getBuildAndReleases?pageNumber=0',
        GET_MESSAGE_TYPE: 'api/mis/getListSMSType',
        POST_NEW_BUILD: 'api/mis/saveBuildAndReleases',
        DISABLE_BUILD: 'api/mis/removeBuildAndReleases',
        SAVE_DETAILS_OF_USER: 'api/users/saveBankInternalUserMang',
        GET_INTERNAL_USER: 'api/users/getBankInternalUserMang',
        GET_DOCUMENT_LIST: 'api/master/getDocumentType',
        GET_DRP_DETAILS: 'api/users/getBankInternalUserMangList',
        APPROVE_USER: 'api/users/approvedUser',
        ODOP_LIST: 'api/master/getMasterOdopList',
        GET_ODOP_PRODUCT: 'api/master/getOdopProduct/',
        REMOVE_EXTERNAL_SERVICE: 'api/mis/removeExternalServiceTokens/',
        DISABLE_EXTERNAL_SERVICE: 'api/mis/updateExternalServiceTokens/',
        ENABLE_EXTERNAL_SERVICE: 'api/mis/updateExternalServiceTokens/',
        ADD_SERVICE_TOKEN: 'api/mis/saveExternalServiceTokens',
        EXTEND_USER_VALIDITY: 'api/users/saveBackInternalUsersValidity',
        GRANT_RELEASE: 'api/mis/grantsSubsidyFileUpload',
        UPDATE_ODOP: 'api/master/saveOdopProduct',
        REVERT_DISBURSEMENT: 'api/digitization/uploadDocument/',
        REVERT_DISBURSEMENT_DATA: 'api/bankLinkage/revertSanctionButNotDusbursement',
        GET_FINANCIAL_YEARS: 'api/master/getFinancialYears',
        GET_QUARTER: 'api/master/getQuarterList',
        GET_APPLICATION_STATUS: 'api/kpi/getInternalDashboardAppStatusV1',
        GET_STATE_STATUS: 'api/kpi/getStatePerformance',
        GET_DASHBOARD_KPI: 'api/kpi/getCountsYearWise',
        GET_STATE_DASHBOARD_KPI: 'api/kpi/getStateWiseApplicationCounts',
        GET_DISTRICT_DASHBOARD_KPI: 'api/kpi/getDistrictWiseApplicationCounts',
        GET_TEAM_DETAILS: 'api/misteam/getAllMisTeamDetails',
        REGISTER_TEAM_DETAILS: 'api/misteam/registerBackMisTeam',
        GET_MONTHLY_REPORT: 'api/kpi/getAllKpiCountByFinancialYearMonthWise',
        GET_ZONAL_BANK: 'api/bankLinkage/getZonalOfficeList',
        DELEGATE_ZONAL_BANK: 'api/bankLinkage/forwardTo',
        SHIFT_APPLICATION: 'api/application/shiftPendingApplication',
        ADD_MULTIPLE_DRP: 'api/users/multipalMobileAuthentication',
        BANK_MERGE: 'api/bankLinkage/listOfApplicationForBranchMerging',
        BRANCH_MERGE: 'api/application/mergeApplicationsByHoToOtherBranch',
        GET_APP_DETAILS_TO_CHANGE_TRANSIENT: 'api/application/searchApplicationDetailsByAppNumOrUserId/',
        CHANGE_TRANSIENT: 'api/application/editSanctionedIfscAndTransientAccount',
        GET_DFS_DETAILS: 'api/kpi/getKpiCountForDfs',
        GET_DFS_BANK_DETAILS: 'api/kpi/getKpiCountForDfsBankWise',
        GET_DATA_TO_VERIFY_LOCATION: 'api/application/getLatLongDetails/',
        VERIFY_LOCATION: 'api/application/setLatLongDetails',
        DOWNLOAD_LAT_LONG_REPORT: 'api/reports/downloadLatLongDetails/',
        DOWNLOAD_SUBSIDY_GRANT_CSV: 'api/mis/getCSVForSubsidyDetails/',
        EDIT_SUBSIDY: 'api/application/editSanctionedIfscAndTransientAccount',
        GET_PRAYAS_DATA: 'api/prayasKpi/getPrayasData',
        GET_PRAYAS_DATA_STATE_WISE: 'api/prayasKpi/getPrayasStateDistFyQtData',
        GET_PRAYAS_STATE_FY_DATA: 'api/prayasKpi/getPrayasStateFyData',


    };

    export const COLOR_CODES = [
        '#4d94ff',
        '#F4D03F',
        '#ff3385',
        '#ff8000',
        '#47d147',
        '#16A085',
        '#7DCEA0',
        '#D7BDE2',
        '#7DCEA0',
        '#16A085',
        '#F4D03F',
        '#ff8000',
        '#00ff00',
        '#ff4d4d',
        '#8cff1a',
        '#ff9933',
        '#e699ff',
        '#0040ff',
        '#0099e6',
        '#99ddff',
        '#4da6ff',
        '#ffcc99',
        '#cc6600',
        '#663300',
        '#4dffff',
        '#00cccc',
        '#004d4d',
        '#ffff33',
        '#b3b300',
        '#4d4d00',
        '#ff0066',
    ];

    export class CustomValidators {
        static invalidCode(control: AbstractControl): ValidationErrors | null {
            return { invalidCode: true };
        }


    static emailValidation(control: AbstractControl): ValidationErrors | null {

    if (control.value) {
        var reg = new RegExp(PATTER_VALIDATION.EMAIL);

        if (!reg.test(control.value)) {
            return { invalidEmail: true };
        }
    }

}

    static phoneNumberValidation(control: AbstractControl): ValidationErrors | null {

    if (control.value) {
        var reg = new RegExp(PATTER_VALIDATION.PHONE);

        if (!reg.test(control.value)) {
            return { invalidPhoneNumber: true };
        }
    }

}

    static notGreaterthanTodaysDate(control: AbstractControl): ValidationErrors | null {

    let selectedDate;
    try {
        selectedDate = new Date(control.value.year, control.value.month, control.value.day, 0, 0, 0, 0);
    } catch (error) {
        selectedDate = new Date();
    }
    let current = new Date();
    let todaysDate = new Date(current.getFullYear(), current.getMonth() + 1, current.getDate(), 0, 0, 0, 0);

    let timeDifference = todaysDate.getTime() - selectedDate.getTime();
    if (timeDifference < 0) {
        return { invalidFutureDate: true };
    }
}

    static minimun21AgeValidation(control: AbstractControl): ValidationErrors | null {

    try {
        if (!(new Date(control.value.year + 21, control.value.month - 1, control.value.day) <= new Date())) {
            return { invalidMinimum21Age: true };
        }
    } catch (ex) {
        return null;
    }
}

    static pastDateValidation(control: AbstractControl): ValidationErrors | null {

    let selectedDate;
    try {
        selectedDate = new Date(control.value.year, control.value.month, control.value.day, 0, 0, 0, 0);
    } catch (error) {
        selectedDate = new Date();
    }
    let current = new Date();
    let todaysDate = new Date(current.getFullYear(), current.getMonth() + 6, current.getDate(), 0, 0, 0, 0);

    let timeDifference = todaysDate.getTime() - selectedDate.getTime();
    if (timeDifference <= 0) {
        return { invalidFutureDate: true };
    }
}

}
